<template>
     <div>
        <div class="form-group row justify-content-center" v-if="children.length>0">
          <div class="d-flex flex-row justify-content-center">
            <b-form-group id="input-group-2">
              <b-form-select v-model="childSelected" :options="children" v-on:change=" getHistory()"></b-form-select>
            </b-form-group>
          </div>
        </div>
        <div v-if="childSelected && Object.keys(historyUser).length > 0">
            <observer :observerUser="historyUser" :isHistory=true :myReport=true></observer>
        </div>
     </div>
  </template>

<script>
import observer from '@/components/custom/observer'
import apiClient2 from '@/services/axios/v2'
import { ToastFire } from '@/services/utilities/swal'
import { showErrorMessage } from '@/services/utilities'
import store from 'store'
import apiClient from '@/services/axios'

export default {
  name: 'observationsMyChildren',
  components: {
    observer,
  },
  data() {
    return {
      historyUser: {},
      children: [],
      childSelected: null,
    }
  },
  created() {
    this.userLocalStorage = JSON.parse(store.get('userData'))
    apiClient.get(`/users/check-children/${this.userLocalStorage.id}`).then(response => {
      if (response.data.length > 0) {
        this.children = response.data.map(x => {
          return {
            value: x.idChild,
            text: x.fullName,
          }
        })
      }
      this.children.unshift({ value: null, text: 'Seleccione el estudiante', disabled: true })
    }).catch(e => {
      ToastFire('warning', showErrorMessage(e))
    })
  },
  methods: {
    getHistory() {
      apiClient2.get(`/observations/users/${this.childSelected}`).then(response => {
        this.historyUser = response.data.data
      }).catch(error => {
        ToastFire('warning', showErrorMessage(error))
        this.$router.go(-1)
      })
    },
  },
}
</script>

  <style>
  .ql-snow .ql-tooltip::before {
  content: 'Marcar link' !important;
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after{
    content: 'Guardar' !important;
  }
  </style>
